import React from "react";
import { shallowEqual, useSelector } from "react-redux"
import Lodash from "lodash";
import { Navigate } from "react-router-dom";


const WebApplicationRedirector = () => {
    console.log("WebApplicationRedirector.rendered");
    const webApplicationLanguageISOCode = useSelector((state:any) => state.CoreStore.languageCode?.payload, shallowEqual);
    if ( !Lodash.isEmpty(webApplicationLanguageISOCode) ) {
        return <Navigate to={`/${webApplicationLanguageISOCode}`} replace={true} />;
    }
    return null;
}

const Component = React.memo(WebApplicationRedirector, (prevProps, nextProps) => {
    console.log("WebApplicationRedirector.memo", { prevProps, nextProps });
    return true;
});

export default Component;
